import { useGetUserType } from "@/modules/auth/hooks/userType.hooks";

import {
  Member,
  ManagementType,
  UserManagementModalProps,
  RemoveEntityModalProps,
} from "../types/commonTypes";

interface GetUserTreeDataProps {
  teamId: string;
  members?: Member[];
  handleUserManagementModal?: (props: UserManagementModalProps) => void;
  handleRemoveEntityModal?: (props: RemoveEntityModalProps) => void;
}

export const useGetUserTreeData = () => {
  const { canViewUser, canUpdateUser, canDeleteUser } = useGetUserType();

  const getUserTreeData = ({
    teamId,
    members,
    handleUserManagementModal,
    handleRemoveEntityModal,
  }: GetUserTreeDataProps) => {
    if (!teamId || !members) return [];

    return members.map((member) => ({
      id: member.id,
      parentId: teamId,
      name: `${member.firstname} ${member.lastname}`.trim(),
      type: ManagementType.USER,
      actions: [
        ...(canUpdateUser
          ? [
              {
                text: "Editer cet utilisateur",
                icon: <i className="pi pi-pencil text-[15px]" />,
                onClick: () => {
                  handleUserManagementModal?.({
                    actionType: "edit",
                    teamId,
                    userId: member.id,
                    userData: member,
                  });
                },
              },
            ]
          : []),
        ...(canViewUser
          ? [
              {
                text: "Consulter cet utilisateur",
                icon: <i className="pi pi-eye text-[16.6px]" />,
                onClick: () => {
                  handleUserManagementModal?.({
                    actionType: "show",
                    teamId,
                    userId: member.id,
                    userData: member,
                  });
                },
              },
            ]
          : []),
        ...(canDeleteUser
          ? [
              {
                text: "Détacher cet utilisateur de son équipe",
                icon: (
                  <i className="pi pi-times text-[14px] text-red-FF0000 font-black" />
                ),
                onClick: () => {
                  handleRemoveEntityModal?.({
                    id: member?.id,
                    teamId,
                    userType: ManagementType.USER,
                    actionType: "detach",
                    label: `${member?.firstname} ${member?.lastname}`.trim(),
                  });
                },
              },
              {
                text: "Supprimer cet utilisateur",
                icon: (
                  <i className="pi pi-trash text-[14px] text-red-FF0000 font-semibold" />
                ),
                onClick: () => {
                  handleRemoveEntityModal?.({
                    id: member?.id,
                    userType: ManagementType.USER,
                    actionType: "delete",
                    label: `${member?.firstname} ${member?.lastname}`.trim(),
                  });
                },
              },
            ]
          : []),
      ],
    }));
  };

  return { getUserTreeData };
};
